var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback, useEffect, useRef, useState } from 'react';
import { getAllJobSuggestion } from '@/api/job.api';
import { useOutsideClick } from './use-outside-click';
export var useJobSearchSuggestion = function (_a) {
    var onSearch = _a.onSearch, _b = _a.debounceMs, debounceMs = _b === void 0 ? 300 : _b, _c = _a.minChars, minChars = _c === void 0 ? 2 : _c, _d = _a.searchQuery, searchQuery = _d === void 0 ? '' : _d, selectedSuggestionFilter = _a.selectedSuggestionFilter;
    var _e = useState(searchQuery), query = _e[0], setQuery = _e[1];
    var _f = useState([]), suggestions = _f[0], setSuggestions = _f[1];
    var _g = useState(false), showSuggestions = _g[0], setShowSuggestions = _g[1];
    var _h = useState(false), isLoading = _h[0], setIsLoading = _h[1];
    var _j = useState(selectedSuggestionFilter), selectedSuggestion = _j[0], setSelectedSuggestion = _j[1];
    var searchRef = useRef(null);
    useOutsideClick(searchRef, function () { return setShowSuggestions(false); });
    var loadSuggestions = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var results, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (query.length < minChars) {
                        setSuggestions([]);
                        return [2 /*return*/];
                    }
                    setIsLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, getAllJobSuggestion(query)];
                case 2:
                    results = _a.sent();
                    setSuggestions(results);
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    setSuggestions([]);
                    return [3 /*break*/, 5];
                case 4:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [query, minChars]);
    useEffect(function () {
        var debounceTimer = setTimeout(loadSuggestions, debounceMs);
        return function () { return clearTimeout(debounceTimer); };
    }, [query, loadSuggestions, debounceMs]);
    var handleSubmit = useCallback(function (e) {
        e.preventDefault();
        onSearch({ query: query, suggestion: selectedSuggestion });
        setShowSuggestions(false);
    }, [query, onSearch, selectedSuggestion]);
    var handleSuggestionClick = useCallback(function (suggestion) {
        setQuery(suggestion.name);
        setSelectedSuggestion(suggestion);
        setShowSuggestions(false);
    }, []);
    var handleSearch = useCallback(function (query) {
        setSelectedSuggestion(undefined);
        setQuery(query);
    }, []);
    useEffect(function () {
        setQuery(searchQuery);
    }, [searchQuery]);
    return {
        query: query,
        handleSearch: handleSearch,
        suggestions: suggestions,
        isLoading: isLoading,
        showSuggestions: showSuggestions,
        setShowSuggestions: setShowSuggestions,
        handleSubmit: handleSubmit,
        handleSuggestionClick: handleSuggestionClick,
        searchRef: searchRef,
    };
};
